import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

const solutionRouter: RouteConfig = {
  path: '/solution',
  component: Layout,
  redirect: '/solution/index',
  children: [
    {
      path: '/solution/index',
      name: 'Solution',
      component: () => import('@/views/solution/index.vue'),
      meta: {
        title: 'route.solution',
        icon: 'iconbaojia',
        activeMenu: ['/solution/index'],
        breadcrumb: [
          {title: 'route.solutionList', path: '/solution/index'},
        ],
      },
    },
    {
      path: '/solution/create',
      name: 'CreateSolution',
      props: true,
      component: () => import('@/views/solution/createSolution.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/solution/index'],
        title: 'route.createSolution',
        noCache: true,
        breadcrumb: [
          {title: 'route.solutionList', path: '/solution/index'},
          {title: 'route.createSolution', path: '/solution/create'},
        ],
      },
    },
    {
      path: '/solution/update',
      name: 'UpdateSolution',
      props: true,
      component: () => import('@/views/solution/updateSolution.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/solution/index'],
        title: 'route.updateSolution',
        noCache: true,
        breadcrumb: [
          {title: 'route.solutionList', path: '/solution/index'},
          {title: 'route.updateSolution', path: '/solution/update'},
        ],
      },
    },
  ],
};

export default solutionRouter;
